const hrcu_Iot_Block = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E7':
            return `
            <category 
                name="%{BKY_CATEGORY_IOT}"
                id="hrcu_iot"
                colour="#00d7b1" 
                secondaryColour="#00d7b1">
                

                <block type="hrcu_iot_initIot"/>
                <block type="hrcu_iot_setIotDeviceData"> 
                    <value name="VALUE">
                        <shadow type="text">
                            <field name="TEXT"></field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_iot_getIotDeviceData"/>
                <block type="hrcu_iot_isIotDeviceData">
                    <value name="VALUE">
                        <shadow type="text">
                            <field name="TEXT"></field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_iot_resetIotResult"/>
                ${false ? `
                <block type="hrcu_iot_startWebService"/>
                <block type="hrcu_iot_getWebUrl"/>
                <block type="hrcu_iot_getWebData"/>` : null}
                ${blockSeparator}
            </category>
                `;
        default:
            return `
                <category 
                    name="通讯" 
                    id="hrcu_iot"
                    colour="#00d7b1" 
                    secondaryColour="#00d7b1">
                </category>
                `;
    }
};

export default hrcu_Iot_Block;
